import React from "react";
import { Modal, ModalBody } from "reactstrap";

import {
  AppDownloadPopupImage,
  CilentAppDownloadPopupImage,
  CloseIcon,
} from "@/assets/images";

import "./style.scss";

type AppProps = {
  isDownloadMobileApp: boolean;
  setIsDownloadMobileApp: React.Dispatch<React.SetStateAction<boolean>>;
  loginData: any;
};

const DownloadMobileApp = ({
  isDownloadMobileApp,
  setIsDownloadMobileApp,
  loginData,
}: AppProps) => {
  const handleToggle = () => {
    setIsDownloadMobileApp((prev: boolean) => !prev);
  };
  return (
    <Modal
      className="downloadAppModal"
      isOpen={isDownloadMobileApp}
      toggle={handleToggle}
      size="xl"
      centered
    >
      <button
        className="custom-close-button"
        onClick={handleToggle}
        aria-label="Close"
      >
        <img
          src={CloseIcon}
          alt="close"
        />
      </button>

      <ModalBody style={{ padding: 0, margin: 0 }}>
        {loginData?.user_type === 1 && (
          <img
            src={AppDownloadPopupImage}
            style={{ width: "100%" }}
            alt="app-download"
          />
        )}
        {loginData?.user_type === 2 && (
          <img
            src={CilentAppDownloadPopupImage}
            style={{ width: "100%" }}
            alt="app-download"
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default DownloadMobileApp;
